import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Store } from '@ngxs/store';
import { CatalogFilter } from '../../../data/modules/catalog-data/models/catalog.service';
import { ChangeCatalogFilter } from '../../../data/modules/catalog-data/store/catalog-table.actions';

@Component({
  selector: 'app-right-text-block',
  templateUrl: './right-text-block.component.html',
  styleUrls: ['./right-text-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RightTextBlockComponent {
  @Input() public iconName: string;
  @Input() public title: string;
  @Input() public text: string;
  @Input() public transitionName: string;
  @Input() public transitionLink: string;
  @Input() public catalogFilter: CatalogFilter;
  public icons = CustomIcons;
  public breakPointObserve$ = this.breakpointObserver.observe(['(max-width: 1250px)']);

  constructor(private breakpointObserver: BreakpointObserver, private store: Store) {}

  public filterCatalog(): void {
    if (this.catalogFilter) {
      this.store.dispatch(new ChangeCatalogFilter(this.catalogFilter, false, true));
    }
  }
}
